// Funções para mascarar dados do cliente para fornecedores

export const maskClientName = (fullName: string): string => {
  if (!fullName) return '';
  
  const names = fullName.trim().split(' ');
  if (names.length === 1) {
    return `${names[0][0]}.`;
  }
  
  return `${names[0][0]}. ${names[names.length - 1][0]}.`;
};

export const maskCompanyName = (companyName: string): string => {
  if (!companyName) return '';
  
  const firstWord = companyName.trim().split(' ')[0];
  return `${firstWord[0]}...`;
};

export const maskPhone = (phone: string): string => {
  if (!phone) return '';
  
  // Remove todos os caracteres não numéricos
  const numbers = phone.replace(/\D/g, '');
  
  if (numbers.length < 10) return phone;
  
  // Extrai o DDD (primeiros 2 dígitos)
  const ddd = numbers.substring(0, 2);
  
  // Mascara o resto do número
  const maskedNumber = numbers.substring(2).replace(/\d/g, '*');
  
  return `(${ddd}) ${maskedNumber}`;
};

export const maskCEP = (cep: string): string => {
  if (!cep) return '';
  
  // Remove caracteres não numéricos
  const numbers = cep.replace(/\D/g, '');
  
  if (numbers.length !== 8) return cep;
  
  // Formata o CEP: 00000-000
  return `${numbers.substring(0, 5)}-${numbers.substring(5)}`;
};

export const shouldShowFullClientData = (
  pedidoStatus: string, 
  fornecedorId: number, 
  fornecedorEscolhidoId?: number
): boolean => {
  // Só mostra dados completos se o fornecedor foi escolhido
  return pedidoStatus === 'aprovado' && fornecedorId === fornecedorEscolhidoId;
};

export const getClientDisplayData = (
  clientData: {
    nome: string;
    empresa: string;
    telefone: string;
    cep: string;
  },
  shouldMask: boolean = true
) => {
  if (!shouldMask) {
    return {
      nome: clientData.nome,
      empresa: clientData.empresa,
      telefone: clientData.telefone,
      cep: maskCEP(clientData.cep) // CEP sempre formatado
    };
  }
  
  return {
    nome: maskClientName(clientData.nome),
    empresa: maskCompanyName(clientData.empresa),
    telefone: maskPhone(clientData.telefone),
    cep: maskCEP(clientData.cep)
  };
}; 